import React from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonPrimary} from '@homeaway/react-buttons';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {FormInput} from '@homeaway/react-form-components';
import {MAX_TRIPBOARD_NAME_LENGTH} from '../../constants';

import './CreateTripBoardNewModal.less';

function CreateTripBoardNewModal(props) {
    const {
        handleClickCancel,
        handleClickCreate,
        newBoardName,
        onNameChange,
        showCancel,
        translations,
        isMobile,
        createIsDisabled
    } = props;

    return (
        <div className="create-trip-board-new-modal">
            <form onSubmit={handleClickCreate}>
                <FormInput
                    autoFocus={!isMobile}
                    className="create-trip-board-new-modal__input"
                    id="boardInput"
                    inputClassName="trip-board-text-input"
                    label={translations['tripboards.modal.create.name']}
                    maxLength={MAX_TRIPBOARD_NAME_LENGTH}
                    value={newBoardName}
                    onChange={onNameChange}
                />
                {/*  Removing until we can run a test to insert what gets returned from lbsuuid
                <div className="create-trip-board-new-modal__suggestions">
                    {'i.e. "Austin Trip" or "Bucket List".'}
                </div>
                */}
            </form>
            <div className="create-trip-board-new-modal__buttons">
                {showCancel && (
                    <Button
                        id="cancelButton"
                        className="create-trip-board-new-modal__buttons_cancel"
                        label={translations['tripboards.cancel']}
                        onClick={handleClickCancel}
                        size="sm"
                    />)
                }
                <ButtonPrimary
                    id="createButton"
                    className="create-trip-board-new-modal__buttons_create"
                    label={translations['tripboards.modal.create']}
                    disabled={createIsDisabled}
                    onClick={handleClickCreate}
                    size="sm"
                />
            </div>
        </div>
    );
}

CreateTripBoardNewModal.propTypes = {
    handleClickCancel: PropTypes.func.isRequired,
    handleClickCreate: PropTypes.func.isRequired,
    newBoardName: PropTypes.string.isRequired,
    onNameChange: PropTypes.func.isRequired,
    showCancel: PropTypes.bool.isRequired
};

export default determineIfMobile(CreateTripBoardNewModal);
